import { FC, useState } from 'react';
// Icons
import { FiChevronDown } from 'react-icons/fi';
// Utilities
import { buildUserName, getEndOfPlace } from 'utilities/Utilities';

type Props = {
  position: number;
  team: string;
  totalScore: number;
  players: any[];
  highlighted?: boolean;
  placingFontColor?: string;
  gradientStart?: string;
  gradientEnd?: string;
}

const TeamCard:FC<Props> = ({
  position, team, totalScore, players, highlighted = false, placingFontColor, gradientStart, gradientEnd
}) => {
  const [ isExpanded, setIsExpanded ] = useState(false);

  const handleToggle = () => setIsExpanded((prevState) => !prevState);

  return (
    <div
      className={`
        mb-3 rounded-xl overflow-hidden border
        ${highlighted ? 'border-primary border-2' : 'border-white/20'}
      `}
    >
      <button
        type="button"
        aria-expanded={isExpanded}
        className="w-full flex items-center gap-4 px-4 py-2 text-lg font-bold text-left bg-transparent border-0 cursor-pointer"
        style={{
          color: placingFontColor,
          background: `linear-gradient(to right, ${gradientStart}, ${gradientEnd})`
        }}
        onClick={handleToggle}
      >
        <span className="w-8">{`${position}${getEndOfPlace(position)}`}</span>
        <span className="flex-1 whitespace-nowrap text-ellipsis overflow-hidden">{team}</span>
        <span>{totalScore}</span>
        <FiChevronDown className={`transition-transform ${isExpanded ? 'rotate-180' : ''}`} />
      </button>
      <div
        className={`
          overflow-hidden transition-[max-height] duration-300 ease-in-out
          ${isExpanded ? 'max-h-[1000px]' : 'max-h-0'}
        `}
      >
        <ul className="bg-black/30">
          {players.map((player:any, playerIndex:number) => (
            <li
              key={`player-${playerIndex}`}
              className={`
                flex items-center gap-4 px-4 py-2 text-sm text-primary
                ${playerIndex !== players.length - 1 ? 'border-b border-white/10' : ''}
              `}
            >
              <span className="w-6">{player.position}</span>
              <span className="flex-1 whitespace-nowrap text-ellipsis overflow-hidden">{buildUserName(player)}</span>
              <span>{player.score}</span>
            </li>
          ))}
        </ul>
      </div>
    </div>
  )
}

export default TeamCard;
